<div class="snackbar-content" (click)="navigate()">
    <div class="snackbar-message">
        <div class="message-header">
        </div>
        <div class="message-body">
            <span>{{ data.message }}</span>
        </div>
    </div>
</div>